import { useEffect } from 'react';

/**
 * Locks page scrolling by adding the `overflow-lock` class to <html> while
 * `locked` is true (mobile menu, modals, …). Always cleaned up on unmount.
 */
export function useScrollLock(locked: boolean) {
    useEffect(() => {
        if (locked) {
            document.documentElement.classList.add('overflow-lock');
        } else {
            document.documentElement.classList.remove('overflow-lock');
        }

        return () => {
            document.documentElement.classList.remove('overflow-lock');
        };
    }, [locked]);
}
